<template>
  <div>
    <div style="display: inline-block" class="recyle-date">
      <el-date-picker
        v-model="value1"
        type="date"
        :picker-options="pickerOptions"
        placeholder="选择日期"
      ></el-date-picker>
    </div>
    <div style="display: inline-block" class="recyle-time">
      <el-time-picker v-model="value2" arrow-control placeholder="选择时间"></el-time-picker>
    </div>
  </div>
</template>

<script>
import { timeToLocal } from "../utils/utils";
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        }
      }
    };
  },
  props: ["date"],
  computed: {
    value1: {
      get: function() {
        if (this.date) {
          let _date = this.date.replace(/\-/g, "/");
          return new Date(_date).getTime();
        }
      },
      set: function(val) {
        this.changeDate(val);
      }
    },
    value2: {
      get: function() {
        if (this.date) {
          let _date = this.date.replace(/\-/g, "/");
          return new Date(_date).getTime();
        }
      },
      set: function(val) {
        this.changeTime(val);
      }
    }
  },
  methods: {
    timeToLocal(date) {
      if (!date) return {};
      date = new Date(date);
      const datetmp = `${date.getFullYear()}-${
        date.getMonth() + 1 >= 10
          ? date.getMonth() + 1
          : `0${date.getMonth() + 1}`
      }-${date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`}`;
      const time = `${
        date.getHours() >= 10 ? date.getHours() : `0${date.getHours()}`
      }:${
        date.getMinutes() >= 10 ? date.getMinutes() : `0${date.getMinutes()}`
      }:${
        date.getSeconds() >= 10 ? date.getSeconds() : `0${date.getSeconds()}`
      }`;
      const datetime = `${datetmp} ${time}`;
      return {
        date: datetmp,
        time: time,
        datetime
      };
    },

    changeDate(val) {
      let date = this.timeToLocal(val).date;
      let time = this.timeToLocal(this.value2).time;
      this.$emit("change", { date, time });
    },
    changeTime(val) {
      let date = this.timeToLocal(this.value1).date;
      let time = this.timeToLocal(val).time;
      this.$emit("change", { date, time });
    }
  }
};
</script>

<style lang="scss" scoped>
.recyle-date .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px;
}
.recyle-time .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 130px;
}
</style>



// WEBPACK FOOTER //
// src/components/recyleDate.vue